import React, { useEffect } from "react";

const ComprasFacturasPage = () => {
  useEffect(() => {
    document.title = "Compras - Facturas | Saas";
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-3">Facturas de compra</h4>
            <p className="text-muted mb-0">
              Espacio reservado para la carga y conciliación de comprobantes de proveedores. Próximamente
              se integrará con contabilidad y tesorería para completar el circuito.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComprasFacturasPage;
